import { Form } from 'components/Form'
import { EditForm } from './EditForm'
import { useUpdatePublisherWorkspaceRole } from './hooks/useUpdatePublisherWorkspaceRole'
import { commonSchema, CommonSchema, editSchemaDefault } from './schemas'
import { EditFormContainerProps } from './types'

export const EditFormContainer = ({
  id,
  userWorkspace,
  workspaceOptions,
}: EditFormContainerProps): React.JSX.Element => {
  const {
    errors: apiErrors,
    loading: loadingUpdate,
    updatePublisherWorkspaceRole,
  } = useUpdatePublisherWorkspaceRole()
  const formId = `${id}-${userWorkspace.userId}`

  return (
    <Form<CommonSchema>
      externalErrors={apiErrors}
      id={formId}
      loading={loadingUpdate}
      onSubmit={updatePublisherWorkspaceRole}
      schema={commonSchema}
      schemaDefaults={editSchemaDefault({ userWorkspace, workspaceOptions })}
    >
      {() => <EditForm workspaceOptions={workspaceOptions} />}
    </Form>
  )
}
